module.exports = __webpack_public_path__ + "img/info_icon.73dc5950.svg";